/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import daftar Tugas
import RMList from '../views/daftar-tugas/RMList.vue';
import RMHistoryList from '../views/daftar-tugas/RMHistoryList.vue';
import HOList from '../views/daftar-tugas/HOList.vue';
import HOHistoryList from '../views/daftar-tugas/HOHistoryList.vue';
import EditMerchant from '../views/daftar-tugas/EditMerchant.vue';
import EditAggregator from '../views/daftar-tugas/EditAggregator.vue';
import MWList from '../views/daftar-tugas/MWList.vue';
import DTMerchantDetail from '../views/daftar-tugas/DTMerchantDetail.vue';
import MWHistoryList from '../views/daftar-tugas/MWHistoryList.vue';

import { setBreadcrumb } from './index';

const daftarTugasRoute = {
  path: '/daftar-tugas',
  name: 'DaftarTugas',
  meta: {
    title: 'BNI QRIS - Daftar Tugas',
    appBarTitle: 'Daftar Tugas',
  },
  component: Parent,
  children: [
    {
      path: '/daftar-tugas/inputer-list',
      meta: {
        title: 'BNI QRIS - Daftar Tugas Inputer',
        appBarTitle: 'Daftar Tugas Inputer',
        breadcrumbs: () => [
          setBreadcrumb('request list', '/daftar-tugas', true),
          setBreadcrumb('inputer list', '/daftar-tugas/inputer-list'),
        ],
      },
      component: RMList,
      name: 'DaftarTugasInputer',
    },
    {
      path: '/daftar-tugas/inputer-list/revisi-merchant/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Edit Merchant',
        appBarTitle: 'Edit Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('request list', '/daftar-tugas', true),
            setBreadcrumb('inputer list', '/daftar-tugas/inputer-list'),
            setBreadcrumb(
              'revisi merchant',
              '/daftar-tugas/inputer-list/revisi-merchant',
              true
            ),
            setBreadcrumb(
              `${id}`,
              `/daftar-tugas/inputer-list/revisi-merchant/${id}`
            ),
          ];
        },
      },
      component: EditMerchant,
      name: 'EditMerchant',
    },
    {
      path: '/daftar-tugas/inputer-list/revisi-aggregator/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Edit Aggregator',
        appBarTitle: 'Edit Aggregator',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('request list', '/daftar-tugas', true),
            setBreadcrumb('inputer list', '/daftar-tugas/inputer-list'),
            setBreadcrumb(
              'revisi aggregator',
              '/daftar-tugas/inputer-list/revisi-aggregator',
              true
            ),
            setBreadcrumb(
              `${id}`,
              `/daftar-tugas/inputer-list/revisi-aggregator/${id}`
            ),
          ];
        },
      },
      component: EditAggregator,
      name: 'EditAggregator',
    },
    {
      path: '/daftar-tugas/inputer-history-list',
      meta: {
        title: 'BNI QRIS - Daftar History Tugas Inputer',
        appBarTitle: 'Daftar History Tugas Inputer',
        breadcrumbs: () => [
          setBreadcrumb('request list', '/daftar-tugas', true),
          setBreadcrumb(
            'inputer history list',
            '/daftar-tugas/inputer-history-list'
          ),
        ],
      },
      component: RMHistoryList,
      name: 'DaftarHistoryTugasInputer',
    },
    {
      path: '/daftar-tugas/approver-2-list',
      meta: {
        title: 'BNI QRIS - Daftar Tugas Approver 2',
        appBarTitle: 'Daftar Tugas Approver 2',
        breadcrumbs: () => [
          setBreadcrumb('request list', '/daftar-tugas', true),
          setBreadcrumb('approver 2 list', '/daftar-tugas/approver-2-list'),
        ],
      },
      component: HOList,
      name: 'DaftarTugasApprover2',
    },
    {
      path: '/daftar-tugas/approver-2-history-list',
      meta: {
        title: 'BNI QRIS - Daftar History Tugas Approver 2',
        appBarTitle: 'Daftar History Tugas Approver 2',
        breadcrumbs: () => [
          setBreadcrumb('request list', '/daftar-tugas', true),
          setBreadcrumb(
            'approver 2 history list',
            '/daftar-tugas/approver-2-history-list'
          ),
        ],
      },
      component: HOHistoryList,
      name: 'DaftarHistoryTugasApprover2',
    },
    {
      path: '/daftar-tugas/approver-1-list',
      meta: {
        title: 'BNI QRIS - Daftar Tugas Approver 1',
        appBarTitle: 'Daftar Tugas Approver 1',
        breadcrumbs: () => [
          setBreadcrumb('request list', '/daftar-tugas', true),
          setBreadcrumb('approver 1 list', '/daftar-tugas/approver-1-list'),
        ],
      },
      component: MWList,
      name: 'DaftarTugasApprover1',
    },
    {
      path: '/daftar-tugas/approver-1-history-list',
      meta: {
        title: 'BNI QRIS - Daftar History Tugas Approver 1',
        appBarTitle: 'Daftar History Tugas Approver 1',
        breadcrumbs: () => [
          setBreadcrumb('request list', '/daftar-tugas', true),
          setBreadcrumb(
            'approver 1 history list',
            '/daftar-tugas/approver-1-history-list'
          ),
        ],
      },
      component: MWHistoryList,
      name: 'DaftarHistoryTugasApprover1',
    },
    {
      path: '/daftar-tugas/:view/view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - View Detail',
        appBarTitle: 'View Detail',
        breadcrumbs: (params) => {
          const { view } = params;
          const { id } = params;
          return [
            setBreadcrumb('request list', '/daftar-tugas', true),
            setBreadcrumb(
              `${view.replaceAll('-', ' ')}`,
              `/daftar-tugas/${view}`
            ),
            setBreadcrumb('detail', `/daftar-tugas/${view}/view`, true),
            setBreadcrumb(`${id}`, `/daftar-tugas/${view}/view/${id}`),
          ];
        },
      },
      component: DTMerchantDetail,
      name: 'Approver1ViewDetail',
    },
  ],
};

export default daftarTugasRoute;
